import { useEffect, useState } from 'react';
import { useCommonStore } from '../../stores/commonStore';
import { getRequest, getProductsforAllFSNs, markRequestAsComplete, getProductsforRequest } from '../../utils/api/requestApi';
import { useRequestorStore } from '../../stores/requestorStore';
import { Link, useParams } from 'react-router-dom';
import { IProduct, Media } from '../../types/product';
import EditableTextInput from '../../components/common/TextInputs/EditableTextInput';
import IconButton from '../../components/common/Buttons/IconButton';
import ProductCard from '../../components/common/ProductCard';
import ProductsBottomBar from './ProductsBottombar';
import { useAuthStore } from '../../stores/authStore';
import { UserInfo } from '../../types/auth';
import { ModelStatuses, Roles } from '../../utils/enums';
import { Routes } from '../../utils/constants/routes';
import { IRequestInfo } from '../../types/requester';
import { useHistory } from 'react-router-dom';
import { downloadModelUrl } from '../../utils/commonUtils';
import Popover from '../../components/common/Popover';
import fetchAndZip from '../../utils/downloadModelUtil';
import DownloadModelsPopup from '../../components/DownloadModelsPopup';
import TablePlainDataCell from '../../components/common/Table/TablePlainDataCell';
import TableHeaderCell from '../../components/common/Table/TableHeaderCell';
import ProductListCard from '../../components/common/ProductListCard';
interface QueryParams {
    id: string;
}

const Products = () => {
    const setLoading = useCommonStore((state) => state.setLoading);
    const loading = useCommonStore((state) => state.loading);
    const setProducts = useRequestorStore((state) => state.setProducts);
    const activeProduct = useRequestorStore((state) => state.activeProduct);
    const products: IProduct[] = useRequestorStore((state) => state.products);
    const [filteredProducts, setFilteredProducts] = useState(products);
    const fsns = useRequestorStore((state) => state.fsns);
    const setFsns = useRequestorStore((state) => state.setFsns);
    const setActiveProduct = useRequestorStore((state) => state.setActiveProduct);
    const setActiveRequest = useRequestorStore((state) => state.setActiveRequest);
    const setToastMessage = useCommonStore((state) => state.setToastMessage);
    const activeRequest: IRequestInfo | null = useRequestorStore((state) => state.activeRequest);
    const setDownloadProgress = useCommonStore((state) => state.setDownloadProgress);
    const setShowDownloadDropdown = useCommonStore((state) => state.setShowDownloadDropdown);
    const headerData: string[] = ['', 'FSN', 'Status', '', ''];
    const { id } = useParams<QueryParams>();
    const user: UserInfo = useAuthStore((state) => state.user);
    const activeRole = useAuthStore((state) => state.activeRole);
    const [approvedNum, setApprovedNum] = useState(0);
    const [rejectedNum, setRejectedNum] = useState(0);
    const isVendor = activeRole === Roles.THREED_ARTIST;
    const [openDownloadPopup, setOpenDownloadPopup] = useState(false);
    const [isListView, setListView] = useState(false);

    const history = useHistory();
    const getFilteredProducts = async (modelFilterValue: string, productsList: IProduct[]) => {
        const requiredProductData: IProduct[] = [];
        productsList.forEach((product: IProduct) => {
            if (product.modelStatus === modelFilterValue || modelFilterValue === 'SHOW_ALL') {
                requiredProductData.push(product);
            }
        });
        setFilteredProducts(requiredProductData);
    };

    const getProducts = async () => {
        try {
            setLoading(true);
            if (id) {
                const response = await getRequest(id);
                const productFsns = response.data.products.map((product: IProduct) => product.fsn);
                setFsns(productFsns);
                const responseFromZulu = await getProductsforRequest(id);
                const productStatuses: String[] = [];
                const requiredProductData: IProduct[] = [];
                const sortedProducts = response.data.products.sort((a, b) => parseFloat(a.priority) - parseFloat(b.priority));
                for (let i = 0; i < responseFromZulu.data.productCards.length; i++) {
                    const newObject = { ...responseFromZulu.data.productCards[i], medias: sortedProducts[i].medias, modelStatus: sortedProducts[i].status };
                    requiredProductData.push(newObject);
                    productStatuses.push(sortedProducts[i].status);
                }
                setActiveRequest(response.data);
                setProducts(requiredProductData);
                let allStatusValues = Object.values(productStatuses);
                getFilteredProducts('SHOW_ALL', requiredProductData);
                setApprovedNum(allStatusValues.filter((status) => status === ModelStatuses.APPROVED).length || 0);
                //hiding temporarily
                // setPendingNum(allStatusValues.filter((status) => status === ModelStatuses.CREATION_IN_PROGRESS).length);
                // setRejectedNum(allStatusValues.filter((status) => status === ModelStatuses.CHANGES_REQUESTED).length);
            } else {
                const responseFromZulu = await getProductsforAllFSNs(fsns);
                setProducts(responseFromZulu.data.productCards);
                getFilteredProducts('SHOW_ALL', responseFromZulu.data.productCards);
            }
        } catch (error) {
            console.log('error', error);
        }
        setLoading(false);
    };

    const handlePrimaryButtonAction = (index: number, modelStatus: undefined | string, medias: any) => {
        if (activeRole === Roles.THREED_ARTIST) {
            history.push(Routes.VENDOR_ROUTES.UPLOAD_3D_MODELS.replace(':id', id));
        } else {
            downloadModelUrl(medias[0]?.url);
        }
    };
    const handleSecondaryButtonAction = (index: number, medias: any) => {
        setActiveProduct(products[index]);
        // review 3d model
        let userRoute = '';
        if (activeRole === Roles.REQUESTOR) {
            userRoute = Routes.REQUESTER_ROUTES.REVIEWS;
        } else if (activeRole === Roles.OPS_MANAGER) {
            userRoute = Routes.OPS_ROUTES.REVIEWS;
        } else {
            userRoute = Routes.VENDOR_ROUTES.REVIEWS;
        }

        history.push(`${userRoute.replace(':requestId/:productId', `${id}/${products[index].fsn}`)}`, { modelUrl: medias[0].url, routedActiveProduct: products[index], userType: activeRole });
    };
    const handleMarkAsComplete = async (id: string) => {
        try {
            await markRequestAsComplete(id);
            setToastMessage({ type: 'success', message: 'Marked as Complete' }, 1000, () => {
                history.push(Routes.REQUESTER_ROUTES.REQUESTS);
            });
        } catch (e) {
            setToastMessage({ type: 'error', message: 'Something went wrong' });
            console.error(e);
        }
    };

    const handleFailedDownload = (e) => {
        setToastMessage({ type: 'error', message: 'Something went wrong' });
        console.error(e);
    };

    useEffect(() => {
        getProducts();
        return () => {
            setProducts([]);
        };
    }, []);

    const pendingNum = Math.abs((products?.length || 0) - approvedNum);

    const availableModels = (arr) => {
        const productsWithModels = arr.filter((product) => product.medias.length !== 0);
        const urls = productsWithModels.map((product) => {
            return { name: product.fsn, url: product.medias[0].url };
        });
        return urls;
    };
    const approvedModels = (arr) => {
        const approvedModels = arr.filter((product) => product.modelStatus === ModelStatuses.APPROVED);
        const productsWithModels = approvedModels.filter((product) => product.medias.length !== 0);
        const urls = productsWithModels.map((product) => {
            return { name: product.fsn, url: product.medias[0].url };
        });
        return urls;
    };

    const handleModelFilter = (e) => {
        getFilteredProducts(e.target.value, products);
    };

    const toggleListView = () => {
        setListView((prevValue) => !prevValue);
    };
    const downloadApprovedModels = () => fetchAndZip(approvedModels(products), setDownloadProgress, setShowDownloadDropdown, activeRequest?.id.toString(), handleFailedDownload);

    const downloadAllModels = () => fetchAndZip(availableModels(products), setDownloadProgress, setShowDownloadDropdown, activeRequest?.id.toString(), handleFailedDownload);

    if (!loading && !(products?.length > 0)) return <div>No data found</div>;

    return (
        <div className="container mx-auto p-8 pb-0 h-full flex flex-col">
            <Popover
                open={openDownloadPopup}
                onClose={() => {
                    setOpenDownloadPopup(false);
                }}
            >
                <DownloadModelsPopup
                    onCancel={() => {
                        setOpenDownloadPopup(false);
                    }}
                    downloadApprovedModels={downloadApprovedModels}
                    downloadAllModels={downloadAllModels}
                    availableModels={availableModels(products)}
                    approvedModels={approvedModels(products)}
                />
            </Popover>

            <div className="pb-1">
                <div className="mb-3 sm:mb-0 w-full flex items-center justify-between py-4 body-bg-color sticky top-0 pb-4 z-10">
                    <div className="">
                        <div className="flex items-center mb-2">
                            <div className="text-xl font-semibold text-black mr-4 flex items-center">
                                Pending Reviews
                                <svg className="ml-4" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M0.380479 19.01C0.870479 19.5 1.66048 19.5 2.15048 19.01L10.4605 10.7C10.8505 10.31 10.8505 9.67999 10.4605 9.28999L2.15048 0.979988C1.66048 0.489988 0.870479 0.489988 0.380479 0.979988C-0.109521 1.46999 -0.109521 2.25999 0.380479 2.74999L7.62048 9.99999L0.370478 17.25C-0.109522 17.73 -0.109521 18.53 0.380479 19.01Z"
                                        fill="#AFAFAF"
                                    />
                                </svg>
                            </div>
                            <div className="text-black-600 text-xl overflow-ellipsis block font-semibold">Request-{id}</div>
                            {/* <EditableTextInput textColor="text-blue-600" value={`Request-${id || 'draft'}`} placeholder="Request #ABC760" size={10} onTextChangeDone={(value) => console.log(value, 'TEXTTEXTTEXT')} /> */}
                        </div>
                        <div className="text-gray-500 whitespace-no-wrap text-base capitalize">Select an item, verify the visual quality & drop your feedback</div>
                    </div>
                    <div onChange={handleModelFilter}>
                        <select onChange={(e) => console.log('dropdown', e)} defaultValue="SHOW_ALL" className="border px-4 py-2 complexity_dropdow shadow-sm rounded-md bg-gray-50">
                            <option value="SHOW_ALL">Select Models</option>
                            <option value={ModelStatuses.APPROVED}>Approved</option>
                            <option value={ModelStatuses.CHANGES_REQUESTED}>Changes Requested</option>
                            <option value={ModelStatuses.CREATION_IN_PROGRESS}>Creation in Progress</option>
                            <option value={ModelStatuses.READY_FOR_REVIEW}>Ready for Review</option>
                        </select>
                    </div>
                    <div onClick={toggleListView} className=" border px-4 py-2 shadow-sm rounded-md cursor-pointer bg-gray-50">
                        {isListView ? 'List View' : 'Card View'}
                    </div>
                    <div className=" flex">
                        {isVendor && (
                            <div className=" pr-1">
                                <Link to={Routes.VENDOR_ROUTES.UPLOAD_3D_MODELS.replace(':id', id)}>
                                    <IconButton label="Upload bulk" color="blue">
                                        <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M5.5 13H9.5C10.05 13 10.5 12.55 10.5 12V6.99997H12.09C12.98 6.99997 13.43 5.91997 12.8 5.28997L8.21 0.699971C7.82 0.309971 7.19 0.309971 6.8 0.699971L2.21 5.28997C1.58 5.91997 2.02 6.99997 2.91 6.99997H4.5V12C4.5 12.55 4.95 13 5.5 13ZM1.5 15H13.5C14.05 15 14.5 15.45 14.5 16C14.5 16.55 14.05 17 13.5 17H1.5C0.95 17 0.5 16.55 0.5 16C0.5 15.45 0.95 15 1.5 15Z"
                                                fill="white"
                                            />
                                        </svg>
                                    </IconButton>
                                </Link>
                            </div>
                        )}

                        {availableModels(products).length !== 0 && (
                            <div>
                                <IconButton label="Download Models" color="blue" onClick={() => setOpenDownloadPopup(true)}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M16.59 9H15V4C15 3.45 14.55 3 14 3H10C9.45 3 9 3.45 9 4V9H7.41C6.52 9 6.07 10.08 6.7 10.71L11.29 15.3C11.68 15.69 12.31 15.69 12.7 15.3L17.29 10.71C17.92 10.08 17.48 9 16.59 9ZM5 19C5 19.55 5.45 20 6 20H18C18.55 20 19 19.55 19 19C19 18.45 18.55 18 18 18H6C5.45 18 5 18.45 5 19Z"
                                            fill="white"
                                        />
                                    </svg>
                                </IconButton>
                            </div>
                        )}
                    </div>
                </div>
                {isListView ? (
                    <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
                        <div className="inline-block min-w-full shadow-sm rounded-lg overflow-hidden">
                            <table className="min-w-full leading-normal table-auto">
                                <thead>
                                    <tr>
                                        {headerData?.map((title) => (
                                            <TableHeaderCell label={title} />
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredProducts &&
                                        filteredProducts.map(({ productImages, fsn, modelStatus, medias }, index) => (
                                            <ProductListCard
                                                key={fsn}
                                                imageUrl={productImages && productImages[0].url}
                                                fsn={fsn}
                                                medias={medias}
                                                modelStatus={modelStatus}
                                                isVendor={isVendor}
                                                primaryButtonAction={() => handlePrimaryButtonAction(index, modelStatus, medias)}
                                                secondaryButtonAction={() => handleSecondaryButtonAction(index, medias)}
                                                headerData={headerData}
                                            />
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ) : (
                    <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto grid grid-cols-2 gap-x-16 gap-y-12">
                        {filteredProducts &&
                            filteredProducts.map(({ productImages, fsn, modelStatus, medias }, index) => {
                                return (
                                    <ProductCard
                                        key={fsn}
                                        imageUrl={productImages && productImages[0].url}
                                        fsn={fsn}
                                        medias={medias}
                                        modelStatus={modelStatus}
                                        isVendor={isVendor}
                                        primaryButtonAction={() => handlePrimaryButtonAction(index, modelStatus, medias)}
                                        secondaryButtonAction={() => handleSecondaryButtonAction(index, medias)}
                                    />
                                );
                            })}
                    </div>
                )}
            </div>

            <div className="sticky bottom-0 bg-white p-4 shadow-sm mt-auto">
                <ProductsBottomBar
                    userType={activeRole}
                    request={activeRequest}
                    products={products}
                    approved={approvedNum}
                    rejected={rejectedNum}
                    pending={pendingNum}
                    handleSubmitRequest={() => {
                        handleMarkAsComplete(id);
                    }}
                />
            </div>
        </div>
    );
};

export default Products;
